<template>
  <div class="astroCalendarNoteDownloadContainer">
    <div class="astroCalendarNoteDownloadContainer__wrap">
      <div class="astroCalendarNoteDownload">
        <div class="astroCalendarNoteDownload__header">
          预览
          <div class="close_btn" @click="$emit('close')">
            <img src="@/assets/月亮日記/close.svg" alt="" />
          </div>
        </div>
        <div class="astroCalendarNoteDownload__line hidden-mobile-down"></div>
        <div class="astroCalendarNoteDownload__body">
          <!----------------輸出在此-------------- -->
          <!-- !imgObj -->
          <div class="astroCalendarNoteDetailWrap">
            <div
              class="astroCalendarNoteDetail"
              id="astroCalendarNoteDetail"
              v-if="!imgObj"
            >
              <div class="astroCalendarNoteDetail__header">
                <div class="astroCalendarNoteDetail__header__content">
                  <div class="astroCalendarNoteDetail__header__content__date">
                    {{ `${moment(astroCalendarNote.Date).format("MM/DD")}` }}
                    <span>{{
                      `${moment(astroCalendarNote.Date).format("dd")}`
                    }}</span>
                  </div>
                  <div class="astroCalendarNoteDetail__header__content__title">
                    ★ {{ astroCalendarNote.Title }}
                  </div>
                </div>
                <img
                  class="pic2"
                  src="@/assets/月亮日記/筆記裝飾星星大.svg"
                  @load="ready4 = true"
                />
                <img
                  class="pic3"
                  src="@/assets/月亮日記/筆記裝飾星星小.svg"
                  @load="ready5 = true"
                />
                <img
                  class="pic4"
                  src="@/assets/共時曆/star1.svg"
                  @load="ready3 = true"
                />
                <img
                  class="pic5"
                  src="@/assets/共時曆/star2.svg"
                  @load="ready6 = true"
                />
              </div>
              <!-- <div class="astroCalendarNoteDetail__line"></div> -->
              <div class="astroCalendarNoteDetail__body">
                <div
                  class="astroCalendarNoteDetail__body__title"
                  :class="{ infoWrap: splitMoods.length > 2 }"
                >
                  <div class="astroCalendarNoteDetail__body__title__moodsGroup">
                    <div
                      class="astroCalendarNoteDetail__body__title__moodsGroup__mood"
                      v-for="(mood, index) in splitMoods"
                      :key="index"
                      :style="`background-color:${
                        emotionList.find((e) => e.id === mood).color
                      } `"
                    >
                      <img
                        :src="
                          emotionList.find((e) => e.id === mood).active_icon
                        "
                        @load="ready1 = true"
                      />
                    </div>
                  </div>
                  <div class="astroCalendarNoteDetail__body__title__text">
                    <h2>我的心情</h2>
                  </div>
                </div>
                <div class="astroCalendarNoteDetail__body__content">
                  <p v-html="replaceBr(astroCalendarNote.MoodContent)"></p>
                </div>
              </div>
            </div>
            <div class="moondayNoteImg" id="moondayNoteImg" v-else>
              <img :src="imgObj" />
            </div>
          </div>
        </div>
        <div class="astroCalendarNoteDownload__line hidden-mobile-down"></div>
        <div class="astroCalendarNoteDownload__footer">
          <div class="astroCalendarNoteDownload__footer__notice">
            <div class="astroCalendarNoteDownload__footer__notice__pic">
              <img src="@/assets/提示燈泡.svg" alt="" />
            </div>
            <div class="astroCalendarNoteDownload__footer__notice__text">
              简单两步骤，轻松分享到社群～
            </div>
          </div>
          <div class="astroCalendarNoteDownload__footer__tutorial">
            <div class="astroCalendarNoteDownload__footer__tutorial__item">
              <span>1</span>
              <p class="hidden-mobile-down">按右键储存图片</p>
              <p class="hidden-mobile-up">长按图片可储存或分享</p>
            </div>
            <div class="astroCalendarNoteDownload__footer__tutorial__item">
              <span>2</span>
              <p class="hidden-mobile-down">上传分享到社群</p>
              <p class="hidden-mobile-up">来与你的朋友分享吧</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toJpeg, toPng, toSvg } from "html-to-image";
import emotionList from "@/js/emotionList.js";
import moment from "moment";

export default {
  props: ["astroCalendarNote"],
  data() {
    return {
      emotionList,
      imgObj: "",
      ready1: false,
      // ready2: true,
      ready3: false,
      ready4: false,
      ready5: false,
      ready6: false,
    };
  },
  created() {
    this.$store.commit("setLoading_force", true);
  },
  methods: {
    moment,
    initPng() {
      let ua = navigator.userAgent;
      let iOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios
      setTimeout(async () => {
        let node = document.getElementById("astroCalendarNoteDetail");
        let res_1 = await toJpeg(node);
        let res_2 = await toJpeg(node);
        this.imgObj = res_2;
        this.$store.commit("setLoading_force", false);
      }, 500);
    },
    replaceBr(str) {
      return str.replace(/\n/g, "<br />");
    },
  },
  computed: {
    allReady() {
      return (
        this.ready1 &&
        // this.ready2 &&
        this.ready3 &&
        this.ready4 &&
        this.ready5 &&
        this.ready6
      );
    },
    splitMoods() {
      return this.astroCalendarNote.Moods.split("|");
    },
  },
  watch: {
    allReady() {
      if (this.allReady) {
        this.initPng();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/_mixin.scss";
.astroCalendarNoteDownloadContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 300;
  background: rgba(240, 242, 244, 0.15);
  backdrop-filter: blur(30px);
  &__wrap {
    width: 720px;
    height: 860px;
    margin: 60px auto;
    pointer-events: none;
    @include pad {
      width: 100vw;
      height: auto;
      margin: 0;
    }
  }
  .astroCalendarNoteDownload {
    height: 100%;
    width: 100%;
    border-radius: 50px;
    background: #f0f2f4;
    box-shadow: 4px 4px 25px 0px rgba(0, 0, 0, 0.3), -4px -4px 10px 0px rgba(238, 109, 175, 0.22),
      -4px -4px 16px 0px rgba(238, 109, 175, 0.22);
    padding: 36px;
    position: relative;
    pointer-events: auto;
    @include mobile {
      min-height: 100vh;
      border-radius: 0;
      padding: 20px 0 0;
      box-shadow: none;
    }
    &__header {
      padding-bottom: 24px;
      color: #ab956c;
      text-align: center;
      font-size: 24px;
      font-weight: 700;

      @include mobile {
        padding-bottom: 16px;
        padding-right: 16px;
        padding-left: 16px;
        font-size: 20px;
        box-shadow: 4px 4px 25px rgba(0, 0, 0, 0.16), -4px -4px 10px rgba(238, 109, 175, 0.22),
          -4px -4px 16px rgba(238, 109, 175, 0.22);
      }
      .close_btn {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
        @include mobile {
          right: 16px;
          top: 14px;
          width: 36px;
          height: 36px;
        }
      }
    }
    &__line {
      height: 3px;
      width: 100%;
      box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.08) inset;
    }
    &__body {
      min-height: calc(100% - 96px - 200px + 72px);
      word-break: break-all;
      @include center;
      @include mobile {
        min-height: calc(100vh - 80px - 192px + 32px);
        padding-right: 16px;
        padding-left: 16px;
      }
    }

    &__footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #798da5;
      font-size: 15px;
      @include mobile {
        font-size: 13px;
        padding-right: 16px;
        padding-left: 16px;
        padding-bottom: 15px;
        box-shadow: -2px -2px 8px 0px rgba(238, 109, 175, 0.22), -2px -2px 3px 0px rgba(238, 109, 175, 0.22),
          3px -2px 15px 0px rgba(0, 0, 0, 0.13);
      }
      &__notice {
        margin-top: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include mobile {
          margin-top: 16px;
        }
        &__pic {
          width: 32px;
          height: 32px;
          margin-right: 12px;
          @include mobile {
            width: 28px;
            height: 28px;
            margin-right: 8px;
          }
        }
        &__text {
          color: #ab956c;
          font-size: 18px;
          @include mobile {
            font-size: 15px;
          }
        }
      }
      &__tutorial {
        display: flex;
        margin-top: 22px;
        @include mobile {
          flex-direction: column;
        }
        &__item {
          display: flex;
          justify-items: center;
          color: #868686;
          font-size: 16px;
          margin-right: 16px;
          @include mobile {
            margin-bottom: 22px;
          }
          span {
            display: inline-flex;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            justify-content: center;
            align-items: center;
            color: #fff;
            background-color: #ab956c;
            font-size: 14px;
            margin-right: 4px;
          }
          p {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

//下載成圖片的區域
.astroCalendarNoteDetailWrap {
  border: 1px solid #d7d7d7;
}
.astroCalendarNoteDetail {
  width: 480px;
  height: 480px;
  padding: 16px 40px 40px;
  background-color: #f0f2f4;
  display: flex;
  flex-direction: column;
  @include mobile {
    width: calc(100vw - 32px);
    height: calc(100vw - 32px);
    padding: 9px 20px 28px;
  }
  &__header {
    font-weight: 500;
    color: #868686;
    font-size: 16px;
    height: 110px;
    padding: 10px 32px 14px;
    position: relative;
    display: flex;
    justify-content: center;
    &__content {
      padding-top: 6px;
      font-weight: 500;
      text-align: center;
      @include mobile {
        padding-top: 8px;
      }

      &__date {
        color: #ab956c;
        font-size: 28px;
        line-height: 1;
        margin-bottom: 18px;
        @include mobile {
          font-size: 20px;
          line-height: 21px;
          margin-bottom: 12px;
        }
        span {
          font-size: 22px;
          @include mobile {
            font-size: 16px;
            line-height: 21px;
          }
        }
      }
      &__title {
        color: $theme-color-2;
        font-size: 22px;
        line-height: 1;
        margin-bottom: 12px;
        @include mobile {
          font-size: 16px;
          line-height: 21px;
          margin-bottom: 12px;
          white-space: nowrap;
        }
      }
    }
    &__mood {
      width: 52px;
      height: 52px;
      @include center;
      margin-right: 8px;
      img {
        width: 100%;
        height: 100%;
      }
      @include mobile {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }
    }
    & > img {
      position: absolute;
    }
    .pic1 {
      height: 124px;
      width: 124px;
      top: 0;
      right: 0;
      @include mobile {
        height: 106px;
        width: 106px;
      }
    }
    .pic2 {
      width: 16px;
      height: 16px;
      top: 18px;
      left: 50px;
    }
    .pic3 {
      width: 10px;
      height: 10px;
      top: 79px;
      left: 14.35px;
    }
    .pic4 {
      width: 10px;
      height: 10px;
      top: 15px;
      right: 65px;
    }
    .pic5 {
      width: 10px;
      height: 10px;
      top: 73px;
      right: 27px;
    }
  }
  &__line {
    height: 3px;
    width: 100%;
    box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.08) inset;
  }
  &__body {
    margin-top: 8px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #868686;
    word-break: break-all;
    flex-grow: 1;
    height: 100%;
    padding: 16px 20px;
    border-radius: 20px 35px 20px 35px;
    border: 1px solid #d2d2d2;
    @include mobile {
      margin-top: 8px;
      border: none;
      border-top: 1px solid #d2d2d2;
      border-radius: 0;
      padding: 16.5px 0 12px;
      line-height: 1.4;
      font-size: 15px;
    }
    h2 {
      font-weight: 500;
      margin-bottom: 4px;
      color: #ab956c;
    }
    p {
      margin-bottom: 0;
    }
    &__title {
      display: flex;
      align-items: center;
      &.infoWrap {
        flex-direction: column;
        align-items: flex-start;
        .astroCalendarNoteDetail__body__title__moodsGroup {
          margin-bottom: 8px;
        }
      }
      &__moodsGroup {
        display: flex;
        &__mood {
          flex-shrink: 0;
          margin-right: 16px;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          padding: 7.5px;
          img {
            width: 100%;
          }
          @include mobile {
            width: 32px;
            height: 32px;
            margin-right: 12px;
            padding: 6.5px;
          }
        }
      }
      &__text {
        p {
          margin-top: 1em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 7;
          -webkit-box-orient: vertical;
        }
      }
    }

    &__content {
      margin-top: 12px;
      @include mobile {
        margin-top: 8px;
      }
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        @include mobile {
          -webkit-line-clamp: 5;
          max-height: calc(100vw - 32px - 240px);
        }
      }
    }
  }
}
.moondayNoteImg {
  width: 480px;
  height: 480px;
  img {
    width: 100%;
    height: 100%;
  }
  @include mobile {
    width: calc(100vw - 32px);
    height: calc(100vw - 32px);
  }
}
</style>
